var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 22.8182C16.4 21.6131 15.4151 20.6364 14.2 20.6364C12.9849 20.6364 12 21.6131 12 22.8182V30.0909C12 36.1156 16.9251 41 23 41C29.0749 41 34 36.1156 34 30.0909V24.2727C34 23.0676 33.0151 22.0909 31.8 22.0909C30.5849 22.0909 29.6 23.0676 29.6 24.2727V22.8182C29.6 21.6131 28.6151 20.6364 27.4 20.6364C26.1849 20.6364 25.2 21.6131 25.2 22.8182V21.3636C25.2 20.1585 24.2151 19.1818 23 19.1818C21.7849 19.1818 20.8 20.1585 20.8 21.3636V11.1818C20.8 9.97673 19.8151 9 18.6 9C17.3849 9 16.4 9.97673 16.4 11.1818V27.9091V22.8182Z",
    stroke: "url(#paint0_linear_4011_31324)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 2V16",
    stroke: "#105BFB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 4L34 2L36 4",
    stroke: "#105BFB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14L34 16L36 14",
    stroke: "#105BFB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41 9H27",
    stroke: "#105BFB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39 7L41 9L39 11",
    stroke: "#105BFB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29 7L27 9L29 11",
    stroke: "#105BFB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4011_31324",
    x1: 23,
    y1: 9,
    x2: 23,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C4D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28353C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPan);
export default __webpack_public_path__ + "static/media/Pan.6e3a18533d35156dca6862c2f0d6803d.svg";
export { ForwardRef as ReactComponent };